module.exports = __webpack_public_path__ + "img/icon-hbar-outline.79d0fbd6.svg";